module.exports = __webpack_public_path__ + "static/media/paint_mask.14f073bb.gif";